import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9baa31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "password-hint"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password-hint__title" }, "Your password should:", -1))
const _hoisted_4 = { class: "password-hint__list" }
const _hoisted_5 = {
  key: 2,
  class: "error-box"
}
const _hoisted_6 = { class: "router-link-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Have an account? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Login here")
const _hoisted_9 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_10 = {
  key: 0,
  class: "password-hint"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "password-hint__title" }, "Your password should:", -1))
const _hoisted_12 = { class: "password-hint__list" }
const _hoisted_13 = {
  key: 2,
  class: "error-box"
}
const _hoisted_14 = { class: "router-link-wrapper" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Have an account? ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Login here")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.nextStep,
          as: "el-form",
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({errors}) => [
            _createVNode(_component_app_input, {
              ref: "inputEmail",
              "prop-error": _ctx.emailError,
              modelValue: _ctx.emailValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailValue) = $event)),
              modelModifiers: { trim: true },
              inputmode: "email",
              name: "email",
              autocomplete: "email",
              label: _ctx.$localize('registration.email.address'),
              placeholder: _ctx.$localize('registration.email.address.example')
            }, null, 8, ["prop-error", "modelValue", "label", "placeholder"]),
            _createVNode(_component_app_input, {
              id: "passInput",
              modelValue: _ctx.passwordValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordValue) = $event)),
              "prop-error": _ctx.passwordError,
              clearable: "",
              "show-password": "",
              name: "password",
              autocomplete: "new-password",
              label: _ctx.$localize('registration.password'),
              placeholder: _ctx.$localize('registration.your.password')
            }, null, 8, ["modelValue", "prop-error", "label", "placeholder"]),
            (_ctx.isFormTouched)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("ul", _hoisted_4, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.isLonger}])
                    }, " Be at least 6 characters ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsSpecialCharacter}])
                    }, " Contain at least 1 special symbol ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsCapitalLetter}])
                    }, " Contain at least 1 uppercase character ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsNumeric}])
                    }, " Contain at least 1 number ", 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock(_component_app_checkbox, {
                  key: 1,
                  class: "app-form-control",
                  name: "hippa",
                  modelValue: _ctx.hippaValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hippaValue) = $event)),
                  checked: _ctx.hippaValue
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.hipaa')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "checked"]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              disabled: !_ctx.emailValue || !!errors.email && !_ctx.passwordValue || !!errors.password,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.email.button')), 1)
              ]),
              _: 2
            }, 1032, ["disabled"]),
            (_ctx.errorKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_app_alert, {
                    title: _ctx.errorKey,
                    closable: false,
                    center: true,
                    type: "error"
                  }, null, 8, ["title"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_link, {
                class: "router-link",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        (_ctx.createInProgress)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Creating account..."
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createVNode(_component_Form, {
          onSubmit: _ctx.nextStep,
          as: "el-form",
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({errors}) => [
            _createVNode(_component_app_input, {
              ref: "inputEmail",
              "prop-error": _ctx.emailError,
              modelValue: _ctx.emailValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailValue) = $event)),
              modelModifiers: { trim: true },
              inputmode: "email",
              name: "email",
              autocomplete: "email",
              label: _ctx.$localize('registration.email.address'),
              placeholder: _ctx.$localize('registration.email.address.example')
            }, null, 8, ["prop-error", "modelValue", "label", "placeholder"]),
            _createVNode(_component_app_input, {
              id: "passInput",
              modelValue: _ctx.passwordValue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordValue) = $event)),
              "prop-error": _ctx.passwordError,
              clearable: "",
              "show-password": "",
              name: "password",
              autocomplete: "new-password",
              label: _ctx.$localize('registration.password'),
              placeholder: _ctx.$localize('registration.your.password')
            }, null, 8, ["modelValue", "prop-error", "label", "placeholder"]),
            (_ctx.isFormTouched)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("ul", _hoisted_12, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.isLonger}])
                    }, " Be at least 6 characters ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsSpecialCharacter}])
                    }, " Contain at least 1 special symbol ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsCapitalLetter}])
                    }, " Contain at least 1 uppercase character ", 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["password-hint__item", {'password-hint__item--active': _ctx.passwordRequirements.containsNumeric}])
                    }, " Contain at least 1 number ", 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock(_component_app_checkbox, {
                  key: 1,
                  class: "app-form-control",
                  name: "hippa",
                  modelValue: _ctx.hippaValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hippaValue) = $event)),
                  checked: _ctx.hippaValue
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.hipaa')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "checked"]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              disabled: !_ctx.emailValue || !!errors.email && !_ctx.passwordValue || !!errors.password,
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('on-submit'))),
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.email.button')), 1)
              ]),
              _: 2
            }, 1032, ["disabled"]),
            (_ctx.errorKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_app_alert, {
                    title: _ctx.errorKey,
                    closable: false,
                    center: true,
                    type: "error"
                  }, null, 8, ["title"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_router_link, {
                class: "router-link",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]),
        (_ctx.createInProgress)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: "Creating account..."
            }))
          : _createCommentVNode("", true)
      ]))
}